(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-sports-context"] && !Shopify.designMode) return;
  try {
    (()=>{const context=document.querySelector('[data-ls-commercial-context]');if(!context)return;const values={_ls_sport:context.dataset.sport,_ls_objectif:context.dataset.goal,_ls_collection:context.dataset.collection};function fill(form){if(!form?.action?.includes('/cart/add'))return;Object.entries(values).forEach(([key,value])=>{let input=form.querySelector('[name="properties['+key+']"]');if(!input){input=document.createElement('input');input.type='hidden';input.name='properties['+key+']';form.appendChild(input);}input.value=value;});}document.querySelectorAll('form[action*="/cart/add"]').forEach(fill);document.addEventListener('submit',e=>fill(e.target),true);document.addEventListener('click',e=>{const a=e.target.closest('a[href]');if(!a)return;const u=new URL(a.href,location.origin);if(u.origin===location.origin&&u.pathname==='/pages/demander-conseil'&&!u.searchParams.has('sport')&&a.closest('main')){u.searchParams.set('sport',values._ls_sport);u.searchParams.set('objectif',values._ls_objectif);u.searchParams.set('source','/collections/'+values._ls_collection);a.href=u.href;}},true);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-sports-filters"] && !Shopify.designMode) return;
  try {
    (()=>{function init(){const params=new URLSearchParams(location.search);document.querySelectorAll('.ls-sports-filter-form').forEach(form=>{['filter.p.vendor','filter.v.price.gte','filter.v.price.lte'].forEach(name=>{if(params.has(name))form.elements.namedItem(name).value=params.get(name);});});}init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luxing-brand-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('luxing-brand-carousel')){
  class LuxingBrandCarousel extends HTMLElement{
    connectedCallback(){
      this.track=this.querySelector('[data-brand-track]');
      this.firstSet=this.querySelector('.lxbc__set');
      this.cards=[...this.querySelectorAll('[data-brand-card]')];
      if(!this.track||!this.firstSet||!this.cards.length)return;
      this.reduce=matchMedia('(prefers-reduced-motion: reduce)');
      this.offset=0;
      this.last=performance.now();
      this.running=!this.reduce.matches;
      this.visible=true;
      this.speed=24;
      this.boundTick=this.tick.bind(this);
      this.boundResize=()=>this.focusCenter();
      this.boundVisibility=()=>{this.visible=!document.hidden;this.last=performance.now();};
      addEventListener('resize',this.boundResize,{passive:true});
      document.addEventListener('visibilitychange',this.boundVisibility);
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries[0]?.isIntersecting!==false;
        this.last=performance.now();
      },{threshold:.01});
      this.observer.observe(this);
      this.addEventListener('mouseenter',()=>this.running=false);
      this.addEventListener('mouseleave',()=>{if(!this.reduce.matches)this.running=true;this.last=performance.now();});
      this.addEventListener('focusin',()=>this.running=false);
      this.addEventListener('focusout',()=>{if(!this.reduce.matches)this.running=true;this.last=performance.now();});
      this.focusCenter();
      if(!this.reduce.matches)this.raf=requestAnimationFrame(this.boundTick);
    }
    tick(now){
      const dt=Math.min(50,now-this.last);
      this.last=now;
      if(this.running&&this.visible){
        this.offset+=this.speed*(dt/1000);
        const reset=this.firstSet.scrollWidth;
        if(reset>0&&this.offset>=reset)this.offset-=reset;
        this.track.style.transform='translate3d('+(-this.offset)+'px,0,0)';
        this.focusCenter();
      }
      this.raf=requestAnimationFrame(this.boundTick);
    }
    focusCenter(){
      const box=this.getBoundingClientRect();
      const center=box.left+box.width/2;
      let best=null,bestDist=Infinity;
      this.cards.forEach(card=>{
        const r=card.getBoundingClientRect();
        const d=Math.abs((r.left+r.width/2)-center);
        if(d<bestDist){bestDist=d;best=card;}
      });
      this.cards.forEach(card=>card.classList.toggle('is-focus',card===best));
    }
    disconnectedCallback(){
      cancelAnimationFrame(this.raf);
      removeEventListener('resize',this.boundResize);
      document.removeEventListener('visibilitychange',this.boundVisibility);
      this.observer?.disconnect();
    }
  }
  customElements.define('luxing-brand-carousel',LuxingBrandCarousel);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luxing-hero-films"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luxing-hero-films')) {
  class LuxingHeroFilms extends HTMLElement {
    connectedCallback() {
      if (this.scope) return;
      this.scope = new AbortController();
      this.token = 0;
      this.current = -1;
      this.desired = 0;
      this.pending = null;
      this.failed = new Set();
      this.hero = this.closest('.lxmp-hero');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches || Boolean(navigator.connection && navigator.connection.saveData);
      this.interval = Math.max(12, Math.min(60, Number(this.dataset.interval) || 20)) * 1000;
      try { this.copy = JSON.parse(this.dataset.copy || '[]'); } catch (e) { this.copy = []; }
      this.copyRoot = this.hero?.querySelector('[data-lx-hero-copy]');      this.copyTitle = this.hero?.querySelector('[data-lx-hero-title]');
      this.copyTitleWhite = this.hero?.querySelector('[data-lx-hero-title-white]');
      this.copyTitleGold = this.hero?.querySelector('[data-lx-hero-title-gold]');
      this.copyOffer = this.hero?.querySelector('[data-lx-hero-offer]');
      this.copyPrice = this.hero?.querySelector('[data-lx-hero-price]');
      this.copySubtitle = this.hero?.querySelector('[data-lx-hero-subtitle]');
      this.copyPrimary = this.hero?.querySelector('[data-lx-hero-primary]');
      this.copyPrimaryLabel = this.hero?.querySelector('[data-lx-hero-primary-label]');
      this.choices = [...this.querySelectorAll('[data-film-select]')];
      this.toggle = this.querySelector('[data-film-toggle]');
      this.items = [...this.querySelectorAll('[data-lx-film]')].map(node => ({node, kind:'native', video:node.querySelector('video'), stall:null}));
      if (!this.hero || !this.toggle || this.items.length !== 3 || this.items.some(item => !item.video)) return;
      const signal = this.scope.signal;
      this.items.forEach((item, index) => {
        item.node.classList.remove('is-current');
        item.video.muted = true;
        item.video.defaultMuted = true;
        item.video.volume = 0;
        item.video.defaultPlaybackRate = 1;
        item.video.playbackRate = 1;
        item.video.addEventListener('playing', () => this.onPlaying(index), {signal});
        item.video.addEventListener('error', () => this.fail(index, true), {signal});
        item.video.addEventListener('waiting', () => this.watchStall(index), {signal});
        item.video.addEventListener('stalled', () => this.watchStall(index), {signal});
        item.video.addEventListener('timeupdate', () => { clearTimeout(item.stall); item.stall = null; }, {signal});
      });
      this.choices.forEach(button => button.addEventListener('click', () => {
        const index = Number(button.dataset.filmSelect);
        if (!this.items[index]) return;
        this.failed.delete(index);
        this.userPaused = false;
        this.desired = index;
        this.updateControls();
        this.request(index);
      }, {signal}));
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        if (!this.userPaused) this.failed.clear();
        this.sync();
      }, {signal});
      document.addEventListener('visibilitychange', () => this.sync(), {signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.userPaused = true; this.sync(); }
      }, {signal});
      this.visible = this.inViewport();
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, {threshold:0.01});
      this.intersection.observe(this.hero);
      this.dataset.activeIndex = '-1';
      this.sync();
    }

    inViewport() {
      const box = this.hero.getBoundingClientRect();
      return box.bottom > 0 && box.top < innerHeight;
    }

    canRun() { return Boolean(this.scope && this.isConnected && this.visible && !document.hidden && !this.userPaused); }

    updateControls() {
      this.dataset.state = this.userPaused ? 'paused' : 'playing';
      const label = this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.setAttribute('aria-label', label);
      this.toggle.title = label;
      this.choices.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.current)));
    }

    clearTimers() {
      clearTimeout(this.cycleTimer);
      clearTimeout(this.preloadTimer);
      clearTimeout(this.watchdog);
      this.cycleTimer = this.preloadTimer = this.watchdog = null;
      this.items.forEach(item => { clearTimeout(item.stall); item.stall = null; });
    }

    pauseItem(index) {
      const item = this.items[index];
      if (item) item.video.pause();
    }

    sync() {
      if (!this.scope) return;
      this.updateControls();
      if (!this.canRun()) {
        this.clearTimers();
        this.pending = null;
        this.token++;
        this.items.forEach((item,index) => this.pauseItem(index));
      } else if (!this.pending) this.request(this.desired);
    }

    prepare(index) {
      const video = this.items[index].video;
      if (!video.getAttribute('src')) {
        const mobile = matchMedia('(max-width: 767px)').matches && video.dataset.mobileSrc;
        const url = new URL(mobile || video.dataset.src, location.href);
        if (url.protocol !== 'https:') return Promise.reject(new Error('Invalid film URL'));
        video.preload = 'auto';
        video.src = url.href;
        video.load();
      } else if (video.error) video.load();
      return Promise.resolve(video);
    }

    request(index) {
      this.desired = index;
      if (!this.canRun()) return;
      if (this.pending && this.pending.index === index) return;
      this.clearTimers();
      const token = ++this.token;
      this.pending = {index,token};
      this.watchdog = setTimeout(() => {
        if (this.pending && this.pending.token === token) this.fail(index,true);
      }, 12000);
      this.prepare(index).then(video => {
        if (!this.canRun() || !this.pending || this.pending.token !== token) return;
        this.items.forEach((other,otherIndex) => { if (otherIndex !== index && otherIndex !== this.current) this.pauseItem(otherIndex); });
        video.muted = true;
        video.volume = 0;
        video.playbackRate = 1;
        const play = video.play();
        if (play) play.then(() => {
          if (this.canRun() && this.pending && this.pending.token === token && !video.paused && video.readyState >= 2) this.onPlaying(index);
        }).catch(error => {
          if (!this.pending || this.pending.token !== token) return;
          if (error.name === 'NotAllowedError') { this.userPaused = true; this.sync(); }
          else this.fail(index,true);
        });
      }).catch(() => {
        if (this.pending && this.pending.token === token) this.fail(index,true);
      });
    }

    onPlaying(index) {
      if (!this.scope) return;
      if (!this.canRun() || (this.pending ? this.pending.index !== index && this.current !== index : this.current !== index)) {
        this.pauseItem(index);
        return;
      }
      clearTimeout(this.items[index].stall);
      this.items[index].stall = null;
      if (this.pending && this.pending.index === index) {
        clearTimeout(this.watchdog);
        this.watchdog = null;
        this.pending = null;
        this.current = index;
        this.desired = index;
        this.items.forEach((item,itemIndex) => {
          item.node.classList.toggle('is-current', itemIndex === index);
          if (itemIndex !== index) this.pauseItem(itemIndex);
        });
        this.dataset.activeIndex = String(index);
        this.applyCopy(index);
        this.updateControls();
        this.schedule();
      } else if (this.current === index && !this.pending && !this.cycleTimer) this.schedule();
    }

    applyCopy(index) {
      const copy = this.copy && this.copy[index];
      if (!copy || !this.copyRoot) return;
      this.copyRoot.classList.add('is-changing');
      requestAnimationFrame(() => {
        if (this.copyTitleWhite) this.copyTitleWhite.textContent = copy.titleWhite || '';
        if (this.copyTitleGold) this.copyTitleGold.textContent = copy.titleGold || '';
        if (this.copyOffer) this.copyOffer.textContent = copy.offer || '';
        if (this.copyPrice) this.copyPrice.textContent = copy.price || '';
        if (this.copySubtitle) this.copySubtitle.textContent = copy.subtitle || '';
        if (this.copyPrimaryLabel) this.copyPrimaryLabel.textContent = copy.primary || 'Commander';
        if (this.copyPrimary) this.copyPrimary.href = copy.primaryUrl || '#';
        this.copyRoot.classList.remove('is-changing');
      });
    }

    nextIndex(after) {
      for (let step=1;step<=this.items.length;step++) {
        const index = (after + step + this.items.length) % this.items.length;
        if (!this.failed.has(index)) return index;
      }
      return -1;
    }

    schedule() {
      clearTimeout(this.cycleTimer);
      clearTimeout(this.preloadTimer);
      if (!this.canRun() || this.current < 0) return;
      this.preloadTimer = setTimeout(() => {
        if (!this.canRun() || this.pending) return;
        const next = this.nextIndex(this.current);
        if (next >= 0 && next !== this.current) this.prepare(next).catch(() => this.fail(next,true));
      }, Math.max(1000,this.interval-5000));
      this.cycleTimer = setTimeout(() => { this.cycleTimer = null; this.advance(this.current); }, this.interval);
    }

    advance(after) {
      if (!this.canRun()) return;
      const next = this.nextIndex(after);
      if (next < 0) { this.userPaused = true; this.sync(); }
      else this.request(next);
    }

    fail(index,hard) {
      if (!this.scope) return;
      const wasPending = this.pending && this.pending.index === index;
      const wasCurrent = this.current === index;
      this.failed.add(index);
      this.pauseItem(index);
      const item = this.items[index];
      clearTimeout(item.stall);
      item.stall = null;
      if (wasCurrent && hard) {
        item.node.classList.remove('is-current');
        this.current = -1;
        this.dataset.activeIndex = '-1';
        this.updateControls();
      }
      if (wasPending) { clearTimeout(this.watchdog); this.pending = null; this.token++; }
      if (wasPending || wasCurrent) this.advance(index);
    }

    watchStall(index) {
      const item = this.items[index];
      if (!this.canRun() || item.stall || this.current !== index) return;
      item.stall = setTimeout(() => { item.stall = null; this.fail(index,false); },12000);
    }

    disconnectedCallback() {
      if (!this.scope) return;
      this.clearTimers();
      this.scope.abort();
      this.scope = null;
      this.token++;
      this.pending = null;
      this.intersection?.disconnect();
      this.items.forEach((item,index) => {
        this.pauseItem(index);
        item.node.classList.remove('is-current');
        item.video.removeAttribute('src');
        item.video.load();
      });
    }
  }
  customElements.define('luxing-hero-films', LuxingHeroFilms);
}
  } catch(e) { console.error(e); }
})();

})();
